import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class TableauSettings extends Component{
    constructor(props) {
        super(props);
        this.state = {
            userName:"",
            serverName:"",
            serverIP:"",
            _notificationSystem: null,
            loading:false,
            isSubmit:false
        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.get_config();
    }
     onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    get_config(){
        axios.post(config.get('API_URL') + '/tableau/get-tableau-config/', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
               this.setState({
                    userName: response.data.tableau_username,
                    serverName: response.data.tableau_server,
                    serverIP: response.data.server_ip
               })
                //console.log("uuuu", response.data);
        });
    }
    saveSetting(){
        if(this.state.serverName===''){
            this.handleNotificationClick("tr", 3, "Please enter Server Name");
            return false;
        }
        if(this.state.userName===''){
            this.handleNotificationClick("tr", 3, "Please enter User Name");
            return false;
        }
        var str = this.state.userName;
        var arr = str.split(",").map(function(item) {
          return item.trim();
        });
        console.log(arr);
        var filtered = arr.filter(function (el) {
          return el != "";
        });

        console.log(filtered);

        axios.post(config.get('API_URL') + '/tableau/tableau_config/', {
                tableau_username: filtered,
                tableau_server: this.state.serverName,
                server_ip: this.state.serverIP
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                console.log(response.data);
                this.handleNotificationClick("tr", 1, "Record has been successfully Updated.");

        });

    }



    render() { //console.log(this.state.mvalue);
        console.log(this.state.userName);
        console.log(this.state.serverName);
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Settings/Configurations</h4>
                                    {/*<p className="category"></p>*/}

                                </div>
                                <hr className="m-0"/>
                                <div className="content">
                                    <form method="post" action="#" id="#">
                                        <div className="col-md-6 col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Tableau Server Name</label>
                                                <Input id="serverName" name="serverName" value={this.state.serverName}
                                                       onChange={this.onChangeInput.bind(this)} />

                                                <label htmlFor="queryName" className="">Tableau Server IP</label>
                                                <Input id="serverIP" name="serverIP" value={this.state.serverIP}
                                                       onChange={this.onChangeInput.bind(this)} />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="userName" className="">Tableau Username (multiple users can be created using comma separated)</label>
                                                <textarea id="userName" name="userName" value={this.state.userName}
                                                       className = "form-control pricingDescription" onChange={this.onChangeInput.bind(this)} > </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <button width="100%" type="button" className="btn btn-primary" onClick={this.saveSetting.bind(this)} >Save</button>
                                                <div className='sweet-loading'>
                                                    <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={20}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/*<div className="col-md-3 pull-left">*/}
                                        {/*    */}
                                        {/*</div>*/}
                                        <div className="clearfix"></div>
                                    </form>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default TableauSettings